import { render } from "./BandView.vue?vue&type=template&id=b58f778c&ts=true"
import script from "./BandView.vue?vue&type=script&lang=ts"
export * from "./BandView.vue?vue&type=script&lang=ts"

import "./BandView.vue?vue&type=style&index=0&id=b58f778c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__